import { TaskLanguageSelect, TaskSetup } from '@/features/contribution-kit';
import { ValidationGateProgressStrip } from '@/features/validation-gate';

type ValidateAudioSetupProps = {
  t: Record<string, unknown>;
  totalValidations: number;
  languages: Array<{ code: string; name: string; displayName?: string }>;
  selectedLanguage: string;
  onLanguageChange: (code: string) => void;
  isLoading: boolean;
  onStart: () => void;
  onBack: () => void;
};

/** Before a "Valider les audios" session: language, rules, load the batch. */
export function ValidateAudioSetup({
  t,
  totalValidations,
  languages,
  selectedLanguage,
  onLanguageChange,
  isLoading,
  onStart,
  onBack,
}: ValidateAudioSetupProps) {
  const s = (key: string) => String(t[key] ?? '');
  return (
    <TaskSetup
      task="verifyAudio"
      title={s('validateAudioTitle')}
      description={s('validateAudioSubtitle')}
      stats={[
        { value: totalValidations, label: s('totalValidations'), tone: 'success' },
        { value: '~4', label: s('minutesRequired') },
      ]}
      instructions={[1, 2, 3, 4].map((n) => s(`audioValidationInstruction${n}`))}
      notices={<ValidationGateProgressStrip />}
      startLabel={s('loadAudios')}
      onStart={onStart}
      startDisabled={!selectedLanguage}
      starting={isLoading}
      onBack={onBack}
    >
      <div className="space-y-2">
        <label htmlFor="validate-audio-language" className="text-sm font-medium text-foreground">
          {s('selectLanguage')}
        </label>
        <p className="text-sm leading-6 text-muted-foreground">{s('prepareBatchDesc')}</p>
        <TaskLanguageSelect
          id="validate-audio-language"
          value={selectedLanguage}
          onChange={onLanguageChange}
          languages={languages.map((language) => ({ ...language, flag: undefined }))}
          placeholder={s('selectLanguage')}
        />
      </div>
    </TaskSetup>
  );
}
